'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// DOM turds
var TOP_NAV_JSON = exports.TOP_NAV_JSON = 'pfs-nav-json';
var TOP_NAV_WRAPPER = exports.TOP_NAV_WRAPPER = 'pfs-nav-wrapper';
var EXT_SERVICE_HOST_ID = exports.EXT_SERVICE_HOST_ID = 'external-service-host';
var MAIN_PARAMS_ID = exports.MAIN_PARAMS_ID = 'pfs-main-params';
var USER_ASYNC_ID = exports.USER_ASYNC_ID = 'pfs-user-async';
var MAIN_ASYNC_ID = exports.MAIN_ASYNC_ID = 'pfs-main-async';
var VERSION_HASH_ID = exports.VERSION_HASH_ID = 'pfs-version-hash';
var LOGIN_ANCHOR_ID = exports.LOGIN_ANCHOR_ID = 'login-anchor';
var HIDDEN_REG_ID = exports.HIDDEN_REG_ID = 'hidden-reg-details';
var DRAWER_ONLY = exports.DRAWER_ONLY = 'drawer-nav-only';
var UPSELL_ID = exports.UPSELL_ID = 'pfs-upsell';
var UPSELL_CONFIG_ID = exports.UPSELL_CONFIG_ID = 'pfs-upsell-config';
// AB constants
var CONTROL_TREATMENT = exports.CONTROL_TREATMENT = 'CONTROL';
// User links endpoint
var USER_LINKS_ENDPOINT = exports.USER_LINKS_ENDPOINT = '/ajax/nav/UserNavAsync.htm';

var DEFAULT_GUID = exports.DEFAULT_GUID = 'DEFAULT_PFS_REQUEST_GUID';
var DEFAULT_USER_TYPE = exports.DEFAULT_USER_TYPE = 'consumer';


//////////////////
// WEBPACK FOOTER
// ./lib/utils/constants.js
// module id = 194
// module chunks = 0 1